"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return FormViewColumn;
    }
});
const _View = /*#__PURE__*/ _interop_require_default(require("~/models/View"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _extractProps = require("~/helpers/extractProps");
const _serialize = require("~/utils/serialize");
const _globals = require("~/utils/globals");
const _modelUtils = require("~/utils/modelUtils");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let FormViewColumn = class FormViewColumn {
    static async get(context, formViewColumnId, ncMeta = _Noco.default.ncMeta) {
        let viewColumn = formViewColumnId && await _NocoCache.default.get(context, `${_globals.CacheScope.FORM_VIEW_COLUMN}:${formViewColumnId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!viewColumn) {
            viewColumn = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.FORM_VIEW_COLUMNS, formViewColumnId);
            if (viewColumn) {
                viewColumn.meta = viewColumn.meta && typeof viewColumn.meta === 'string' ? JSON.parse(viewColumn.meta) : viewColumn.meta;
                await _NocoCache.default.set(context, `${_globals.CacheScope.FORM_VIEW_COLUMN}:${formViewColumnId}`, viewColumn);
            }
        }
        return viewColumn && new FormViewColumn(viewColumn);
    }
    static async insert(context, column, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(column, [
            'fk_view_id',
            'fk_column_id',
            'show',
            'base_id',
            'source_id',
            'label',
            'help',
            'description',
            'required',
            'enable_scanner',
            'meta'
        ]);
        insertObj.order = await ncMeta.metaGetNextOrder(_globals.MetaTable.FORM_VIEW_COLUMNS, {
            fk_view_id: insertObj.fk_view_id
        });
        if (insertObj.meta) {
            insertObj.meta = (0, _serialize.serializeJSON)(insertObj.meta);
        }
        if (!insertObj.source_id) {
            const viewRef = await _View.default.get(context, insertObj.fk_view_id, ncMeta);
            insertObj.source_id = viewRef.source_id;
        }
        const { id } = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.FORM_VIEW_COLUMNS, insertObj);
        return this.get(context, id, ncMeta).then(async (viewColumn)=>{
            await _NocoCache.default.appendToList(context, _globals.CacheScope.FORM_VIEW_COLUMN, [
                column.fk_view_id
            ], `${_globals.CacheScope.FORM_VIEW_COLUMN}:${id}`);
            return viewColumn;
        });
    }
    static async list(context, viewId, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.FORM_VIEW_COLUMN, [
            viewId
        ]);
        let { list: viewColumns } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !viewColumns.length) {
            viewColumns = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.FORM_VIEW_COLUMNS, {
                condition: {
                    fk_view_id: viewId
                },
                orderBy: {
                    order: 'asc'
                }
            });
            for (const viewColumn of viewColumns){
                viewColumn.meta = (0, _serialize.deserializeJSON)(viewColumn.meta);
            }
            await _NocoCache.default.setList(context, _globals.CacheScope.FORM_VIEW_COLUMN, [
                viewId
            ], viewColumns);
        }
        viewColumns.sort((a, b)=>(a.order != null ? a.order : Infinity) - (b.order != null ? b.order : Infinity));
        return viewColumns == null ? void 0 : viewColumns.map((v)=>new FormViewColumn(v));
    }
    static async update(context, columnId, body, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(body, [
            'label',
            'help',
            'description',
            'required',
            'show',
            'order',
            'meta',
            'enable_scanner'
        ]);
        // update meta
        const res = await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.FORM_VIEW_COLUMNS, (0, _modelUtils.prepareForDb)(updateObj), columnId);
        await _NocoCache.default.update(context, `${_globals.CacheScope.FORM_VIEW_COLUMN}:${columnId}`, (0, _modelUtils.prepareForResponse)(updateObj));
        return res;
    }
    constructor(data){
        Object.assign(this, data);
    }
};
